import { z } from 'zod';

export const zodDlnNumberSuggestionResponseSchema = z.object({
  dlnNr: z.string(),
});
